import React from 'react';
import { BrowserRouter as Router, Route , Switch} from 'react-router-dom';
import './Root.css';

import Stuff from '../Stuff/Stuff';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Download } from '../Download';

function Root(props) {
  let content = null;

  function handleClick() {
    content.scrollIntoView();
  }

  return (
    <Router>
      <Switch>
        <Route path="/download">
          <Download />
        </Route>

        <Route path="*">
          <div className="Root">
            <Header onClick={handleClick}/>
            <div ref={div => content = div}>
              <Stuff/>
            </div>
            <Footer/>
          </div>
        </Route>
      </Switch>
    </Router>
  );
}

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root/Root.js